
export let userid
export let currentUser
export let currentUserFullName
export let currentTenant
export let clientname
export let usertoken
export let roles
export let prefix1
export let thousandsdisplay = "lakh"
export let currency
export let ccountry
export let taxtype
export let clienttz
export let ccity
export let address
export let address2
export let companyemail
export let cstate
export let cstatecode
export let czip
export let contactnumber
export let financialyearstart
export let financialyearend
export let pan
export let tan
export let gstin
export let taxno
export let registrationno
export let plprofit
export let plloss
export let einvoice
export let dataaccess
export let userwhid
export let logo
export let logoDimensions
export let noofusers
export let transactionFrom
export let selectedMenu
export let theme = "modern"

class Credentials {

  setFinancialYearEnd(cfinancialyearend) {
    financialyearend = cfinancialyearend
  }

  setcFinancialYearStart(cfinancialyearstart) {
    financialyearstart = cfinancialyearstart
  }

  setPlprofit(pplprofit) {
    plprofit = pplprofit
  }

  setPlloss(pplloss) {
    plloss = pplloss
  }

  setLogo(logo1) {
    logo = logo1
  }

  setCity(city) {
    ccity = city
  }

  setCompanyemail(email) {
    companyemail = email
  }
  setState(state) {
    cstate = state
  }

  setStatecode(statecode) {
    cstatecode = statecode
  }
  setZip(zip) {
    czip = zip
  }
  setaddress(add) {
    address = add
  }
  setaddress2(add2) {
    address2 = add2
  }


  setContactnumber(num) {
    contactnumber = num
  }

  setcurrentuserId(id) {
    userid = id
  }

  setPrefix(prefix) {
    prefix1 = prefix
  }

  setcurrentUser(username) {
    currentUser = username
  }

  setcurrentUserFullName(name) {
    currentUserFullName = name
  }

  setcurrency(cur) {
    currency = cur
  }

  setccountry(country) {
    ccountry = country
  }

  setTaxtype(type) {
    taxtype = type
  }
  setcurrentTenant(tenantId) {
    currentTenant = tenantId
  }

  setuserToken(token) {
    usertoken = token
  }


  setRoles(userroles) {
    roles = userroles
    // roles = "ROLE_ADMIN"
  }

  thousandsdisplay(t) {
    thousandsdisplay = t
  }
  //thousand or lakh
  setclientname(name) {
    clientname = name
  }

  setclienttz(tz) {
    clienttz = tz
  }

  setpan(panno) {
    pan = panno
  }

  settan(tanno) {
    tan = tanno
  }

  setgstin(gst) {
    gstin = gst
  }

  settaxno(taxnum) {
    taxno = taxnum
  }

  setregistrationno(regno) {
    registrationno = regno
  }

  setEinvoice(einvoice1) {
    einvoice = einvoice1
  }

  setDataaccess(da) {
    dataaccess = da
  }

  setUserwhid(whid) {
    userwhid = whid
  }

  setNoofusers(users) {
    noofusers = users
  }

  setSelectedMenu(menu) {
    selectedMenu = menu
  }
  setTransactionFrom(fromdate) {
    transactionFrom = fromdate;
    // transactionFrom = null;
  }

  setTheme(Theme) {
    theme = Theme
  }

  setLogoDimensions(dimensions) {
    logoDimensions = dimensions
  }
}

export function getFinancialYearLabel(from, to) {
  if (!from) return '';
  const tz =
    clienttz ||
    (currentTenant === 'CLI100008' || ccountry === 'Qatar'
      ? 'Asia/Qatar'
      : ccountry === 'India'
      ? 'Asia/Kolkata'
      : 'UTC');

  try {
    const fDate = new Date(from);
    if (isNaN(fDate.getTime())) throw new Error();
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    const parts = formatter.format(fDate);
    const [yStr, mStr] = parts.split('-');
    const startYear = parseInt(yStr, 10);
    const startMonth = parseInt(mStr, 10);
    const isCalendarYear = startMonth === 1;
    const endYear = isCalendarYear ? startYear : startYear + 1;
    return `${startYear}-${endYear}`;
  } catch (e) {
    const s = String(from).substring(0, 4);
    const yr = parseInt(s, 10) || 0;
    return `${yr}-${yr}`;
  }
}

export default new Credentials()